import { render, staticRenderFns } from "./BucketFilters.vue?vue&type=template&id=8325f136&scoped=true"
import script from "./BucketFilters.vue?vue&type=script&lang=js"
export * from "./BucketFilters.vue?vue&type=script&lang=js"
import style0 from "./BucketFilters.vue?vue&type=style&index=0&id=8325f136&prod&lang=css"
import style1 from "./BucketFilters.vue?vue&type=style&index=1&id=8325f136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8325f136",
  null
  
)

export default component.exports